module.exports = __webpack_public_path__ + "static/media/sunnyvale5.7c8bf971.jpg";